/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

import { ACTION_NODES, ACTION_NODE_BUTTON, ACTION_NODE_LINK } from 'constants/Action';
import validateHref from './Cta.validation';
import Button from './Button';
import Link from './Link';

const Cta = ({ node, href, ...rest }) =>
  node === ACTION_NODE_LINK ? <Link href={href} {...rest} /> : <Button {...rest} />;

Cta.propTypes = {
  node: PropTypes.oneOf(ACTION_NODES),
  href: validateHref,
};

Cta.defaultProps = {
  node: ACTION_NODE_BUTTON,
  href: undefined,
};

export { Cta };
